import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Autocomplete, Skeleton, Stack, TextField, Typography } from '@mui/material';
import Checklists from '../../../../service/Checklists';
import AttToken from '../../../../helpers/attToken';
import { modeloStyleType } from "../../../../service/checklistStyle";
import { trackEventMatomo } from '../../../../helpers/matomo';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import EstilosComp from './EstilosComp';

export type checklistType = {
  id: string,
  nome: string
}

type props = {
  setObjectToEdit: Function,
  objectToEdit: modeloStyleType,
}

const checkListService = new Checklists()

export default function StyleFillModal(
  {
    setObjectToEdit,
    objectToEdit,
  }: props) {
  const [selected, setSelected] = useState('header')
  const { t } = useTranslation('translation');

  const { data, isLoading: loadingSimples, isFetching } = useQuery({
    queryKey: ['GET_SIMPLES'],
    queryFn: async () => {
      const token = await AttToken()
      if (token) {
        const response = await checkListService.getSimples(token)
        return response.cls
      }
    },
    keepPreviousData: true,
    retry: 5,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  })

  const fonts = [
    'Arial',
    'Arial Black',
    'Comic Sans MS',
    'Courier New',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'open sans',
    'Palatino Linotype',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana'
  ]

  return (
    <>
      <Stack
        sx={{ padding: '20px', width: '100%' }}
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}>
        <TextField
          onClick={() => {
            trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona texto')
          }}
          label={'Nome'}
          fullWidth
          value={objectToEdit?.name}
          onChange={(elem) => setObjectToEdit({ ...objectToEdit, name: elem.target.value })}
        />
        {(loadingSimples || isFetching) ? <Skeleton variant='rectangular' height={50} width={'100%'} /> :
          <Autocomplete
            fullWidth
            onClick={() => {
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'select', 'seleciona form')
            }}
            multiple
            value={objectToEdit?.associatedChecklists?.map((ele: string) => (
              {
                label: data?.find((elem: any) => elem.id === ele)?.nome || 'Não encontrado',
                value: ele || ''
              }
            )) || undefined}
            id="combo-box-demo"
            sx={{ marginTop: '10px' }}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            filterSelectedOptions
            disableClearable
            options={
              data
                ?.sort((a: checklistType, b: checklistType) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1 })
                ?.map((ele: checklistType) => ({
                  label: ele.nome,
                  value: ele.id,
                })) || []}
            onChange={(event: any, newValue: { label: string, value: string }[] | null) => {
              setObjectToEdit({ ...objectToEdit, associatedChecklists: newValue?.map((ele) => ele.value) || [] })
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.value}>
                <span>{option.label}</span>
              </li>)}
            renderInput={(params) => <TextField {...params} label={t('teamManage.modal.form')} />}
          />
        }
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selected}
            onChange={(eve) => setSelected(eve.target.value)}
          >
            <MenuItem value={'header'}>{t('checklists.header')}</MenuItem>
            <MenuItem value={'background'}>{t('checklists.background')}</MenuItem>
          </Select>
        </FormControl>
        <EstilosComp objectToEdit={objectToEdit} setObjectToEdit={setObjectToEdit} fonts={fonts} selected={selected} />
      </Stack>
      <Stack>
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          sx={{
            padding: '10px',
            backgroundColor: (objectToEdit?.colorHeader as string)
          }}>
          {objectToEdit.logo && <img width={'100px'} src={objectToEdit?.logo} />}
          <Typography
            sx={{
              color: (objectToEdit?.fontHeader?.color as string),
              fontFamily: (objectToEdit?.fontHeader?.fontFamily as string),
              fontSize: (objectToEdit?.fontHeader?.fontSize as any),
            }}>
            {objectToEdit?.name}
          </Typography>
        </Stack>
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={3}
          sx={{
            width: '100%',
            padding: '20px',
            backgroundColor: (objectToEdit?.background as string) || '#E5E5E5',
          }}>
          <Typography
            sx={{
              color: objectToEdit?.fontBackground?.color,
              fontFamily: objectToEdit?.fontBackground?.fontFamily,
              fontSize: objectToEdit?.fontBackground?.fontSize
            }}
          >
            Nome do item
          </Typography>
          <div style={{ width: '100%' }}>
            <Typography>
              1 - {t('checklists.questionName')}
            </Typography>
            <TextField disabled fullWidth placeholder='Digite o valor' />
          </div>
        </Stack>
        <div
          style={{
            width: '100%',
            height: '50px',
            backgroundColor: (objectToEdit?.colorHeader as string)
          }}></div>
      </Stack>
    </>
  )
}
